import React from 'react'
// import './InfoRow.css'

function DiamondDetailsContent({data}) {
  return (
  <div className="specGrid">
    <div>
      <div className="specRow">
        <div className="specLabel">Stock ID</div>
        <div className='specValue'>{data?.stockID}</div>
      </div>

      <div className="specRow">
        <div className="specLabel">Shape</div>
        <div className='specValue'>{data?.shape}</div>
      </div>

      <div className="specRow">
        <div className="specLabel">Carat</div>
        <div className='specValue'>{data?.carat ? `${data?.carat.toFixed(2)}ct` : "-"}</div>
      </div>

      <div className="specRow">
        <div className="specLabel">Color</div>
        <div className='specValue'>{data?.color ==="fancy" ? `${data?.fancy_intensity} ${data?.fancy_overtone} ${data?.fancy_color}` : data?.color || ""}</div>
      </div>

      <div className="specRow">
        <div className="specLabel">Clarity</div>
        <div className='specValue'>{data?.clarity}</div>
      </div>

      <div className="specRow">
        <div className="specLabel">Cut</div>
        <div className='specValue'>{data?.cut || "-"}</div>
      </div>
    </div>

    <div>
      <div className="specRow">
        <div className="specLabel">Pol.</div>
        <div className='specValue'>{data?.polish}</div>
      </div>

      <div className="specRow">
        <div className="specLabel">Symm.</div>
        <div className='specValue'>{data?.symmetry}</div>
      </div>

      <div className="specRow">
        <div className="specLabel">Flou.</div>
        <div className='specValue'>{data?.fluorescence}</div>
      </div>
      {data?.showsharecertificate && (
        <>
            <div className="specRow">
              <div className="specLabel">Lab</div>
              <div className='specValue'>{data?.lab}</div>
            </div>

            <div className="specRow">
              <div className="specLabel">Certificate</div>
              <div className='specValue'>{data?.certificate}</div>
            </div>

        </>
      )}
    </div>
  </div>
  )
}

export default DiamondDetailsContent